import styled from "styled-components";
import { DEFAULT_OVERLAY_CONFIG } from "./constants";
import { StyledOverlayProps } from "./types";

export const StyledOverlay = styled.div<StyledOverlayProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    background-color: ${(props) => props.backgroundColor};
    opacity: ${(props) => props.opacity};
    z-index: ${({ theme }) => theme.elevation[theme.colorMode].halfcards_And_Popups.zIndex};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity ${DEFAULT_OVERLAY_CONFIG.TRANSITION_DURATION} ease-in-out;
`;
